import { Check } from "@mui/icons-material";
import CheckIcon from "assets/icons/CheckIcon";
import MinusIcon from "assets/icons/MinusIcon";
import { useEffect, useRef, useState } from "react";

export interface SwitchProps {
  onChange?: (active: boolean) => void;
  active?: boolean;
  activeColor?: any;
  disable?: boolean;
  size?: 1 | 2 | 3;
}
export default function Switch(props: SwitchProps) {
  const { onChange, activeColor, disable = false } = props;
  const [active, setActive] = useState(!!props.active);
  useEffect(() => setActive(!!props.active), [props.active]);
  const ref = useRef(true);

  const sizes: any = {
    1: {
      cw: "w-16 min-w-[64px]",
      ch: "h-8",
      sw: "w-6",
      sh: "h-6",
      tr: "translate(-32px)",
      scale: 0.6,
      t: "top-1",
      r: "right-1",
    },
    2: {
      cw: "w-12 min-w-[48px]",
      ch: "h-6",
      sw: "w-4",
      sh: "h-4",
      tr: "translate(-24px)",
      scale: 0.5,
      t: "top-1",
      r: "right-1",
    },
    3: {
      cw: "w-8 min-w-[32px]",
      ch: "h-4",
      sw: "w-3",
      sh: "h-3",
      tr: "translate(-16px)",
      scale: 0.4,
      t: "top-0.5",
      r: "right-0.5",
    },
  };
  const { ch, cw, sw, sh, tr, scale, t, r } = sizes[props.size || 1];

  useEffect(() => {
    setActive(!!props.active);
  }, [props.active]);

  return (
    <div
      className={`${ch} ${cw} top rounded-full transition-all relative cursor-pointer ${
        !active ? "bg-gray-200" : activeColor ? `bg-[#30D74B]` : "bg-blue-200"
      }`}
      onClick={(e) => {
        e.preventDefault();
        const a = !active;
        setActive(a);
        onChange && onChange(a);
      }}
    >
      <div
        style={{ transform: active ? tr : "" }}
        className={`${sh} ${sw} ${t} ${r} rounded-full flex justify-center items-center absolute transition-all  ${
          active ? "bg-blue-600" : "bg-slate-400"
        }`}
      >
        {active && <Check className="text-white" style={{ transform: `scale(${scale})` }} />}
        {!active && <MinusIcon color="#fff" scale={scale} />}
      </div>
    </div>
  );
}
